import {
  GET_SEASON_PASS_FAIL,
  GET_SEASON_PASSES_SUCCESS,
  GET_SEASON_PASS_DETAIL_FAIL,
  GET_SEASON_PASS_DETAIL_SUCCESS,
  ADD_SEASON_PASS_SUCCESS,
  ADD_SEASON_PASS_FAIL,
  UPDATE_SEASON_PASS_SUCCESS,
  UPDATE_SEASON_PASS_FAIL,
  CLEAR_MESSAGE,
  DELETE_SEASON_PASS_SUCCESS,
  DELETE_SEASON_PASS_FAIL,
} from "./actionTypes"
import { statusTypes } from "../../constants/common"

const INIT_STATE = {
  seasonPassList: [],
  seasonPassDetails: {},
  error: {},
  message: "",
  pagination: {},
  search: "",
}

const seasonPass = (state = INIT_STATE, action) => {
  switch (action?.type) {
    case GET_SEASON_PASSES_SUCCESS:
      return {
        ...state,
        seasonPassList: action.payload?.data,
        pagination: action.payload?.pagination || {},
      }

    case GET_SEASON_PASS_FAIL:
      return {
        ...state,
        error: action.payload,
        seasonPassList: [],
      }
    case ADD_SEASON_PASS_SUCCESS:
      let seasonPasss = [...state.seasonPassList]
      seasonPasss.unshift(action?.payload?.data)
      return {
        ...state,
        seasonPassList: seasonPasss,
        message: action?.payload?.message || "",
      }

    case ADD_SEASON_PASS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SEASON_PASS_DETAIL_SUCCESS:
      return {
        ...state,
        seasonPassDetails: action.payload,
      }

    case UPDATE_SEASON_PASS_SUCCESS:
      return {
        ...state,
        message: "Successfully seasonPass updated!",
        seasonPassList: (state?.seasonPassList || []).map(seasonPass => {
          return seasonPass._id.toString() ===
            action.payload?.data._id.toString()
            ? { seasonPass, ...action.payload?.data }
            : seasonPass
        }),
      }

    case UPDATE_SEASON_PASS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SEASON_PASS_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_SEASON_PASS_SUCCESS:
      let list = state?.seasonPassList || []
      const findIndex = list.findIndex(
        seasonPass =>
          seasonPass._id.toString() === action.payload._id.toString()
      )
      if (findIndex > -1 && list.length > 0) {
        list[findIndex].status = statusTypes.Removed
      }
      return {
        ...state,
        message: "Season pass deleted successfully!",
        seasonPassList: list,
      }

    case DELETE_SEASON_PASS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CLEAR_MESSAGE:
      return {
        ...state,
        error: {},
        message: "",
      }

    default:
      return state
  }
}

export default seasonPass
